import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const SelectedZoneSchema_ = z.object({
  profileId: z.string(),
  locationGroupId: z.string(),
  zoneName: z.string(),
});
export const SelectedZoneSchema: z.ZodType<SelectedZoneSchema> =
  SelectedZoneSchema_;
export interface SelectedZoneSchema extends z.infer<
  typeof SelectedZoneSchema_
> {}

export const addRedoCarrierService = {
  name: "addRedoCarrierService" as const,
  input: z.object({
    teamId: zExt.objectId(),
    selectedZones: z.array(SelectedZoneSchema).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    profilesUpdated: z.number(),
    errors: z.array(z.string()).optional(),
  }),
};
